"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const moment_1 = __importDefault(require("moment"));
function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
let SampleElement = class SampleElement extends vue_property_decorator_1.Vue {
    sampleClicked() {
        if (this.mremove)
            this.removeSample();
    }
    formatDate(date) {
        const mdate = (0, moment_1.default)(date);
        const d = mdate.date();
        const m = capitalize(mdate.format('MMM').replace('.', '').toLowerCase());
        const y = mdate.year();
        return `${d}${m}${y}`;
    }
    removeSample() {
        this.$emit('remove', this.sample);
        this.heatmap.rmSample(this.sample.sample);
    }
    created() {
    }
    mounted() {
    }
    get classes() {
        return {
            'mode--check': this.mcheck,
            'bcchecks': this.mcheck,
            'mode--remove': this.mremove,
            'disabled': this.sample.disabled,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SampleElement.prototype, "mremove", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SampleElement.prototype, "mcheck", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SampleElement.prototype, "sample", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SampleElement.prototype, "heatmap", void 0);
SampleElement = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Square: lucide_vue_next_1.Square,
            X: lucide_vue_next_1.X,
            GitMerge: lucide_vue_next_1.GitMerge,
            Info: lucide_vue_next_1.Info
        }
    })
], SampleElement);
exports.default = SampleElement;
